





import Vue from 'vue';
import Component from "vue-class-component";
const feather = require('feather-icons');

@Component({
    props: {
        icon: { required: true },
        xclass: { default: '' },
        stroke: { default: 2 },
        width: { default: 22 },
        height: { default: 22 },
        color: {},
        fill: { default: 'none' }
    },
})

export default class XFeather extends Vue{
    private icon: any;
    private xclass: any;
    private stroke: number = 2;
    private width: number = 22;
    private height: number = 22;
    private color: any;
    private fill: any;

    mounted() {
        if (this.icon) {
            if (feather) {
                this.icon = feather.icons[this.icon].toSvg({
                    class: this.xclass,
                    'stroke-width': this.stroke,
                    color: this.color,
                    fill: this.fill,
                    width: this.width,
                    height: this.height
                });
            }
        }
    }
}   
